import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    pickUpAddress: '',
    dropOffAddress: '',
    pickUp: 0,
    dropOff: 0,
    tripType: '2',
    noOfPassengers: 1,
    departureDate: '',
    departureTime: '',
    departureUnix: 0,
    returnDate: '',
    returnTime: '',
    returnUnix: 0,
    gclid: '',
    formSource: '',
};

const bookingSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        setBookingDetails: (state, action) => {
            return { ...state, ...action.payload };
        },
        clearBookingForm: (state) => {
            return initialState;
        },
        updateField: (state, action) => {
            const { field, value } = action.payload;
            state[field] = value;
        },
    },
});

export const { setBookingDetails, clearBookingForm, updateField } = bookingSlice.actions;
export default bookingSlice.reducer; 